const PackageTypeEnum = {
  LUXURY: 1,
  DELUXE: 2,
  PREMIUM: 3,
  STANDARD: 4
}
export default PackageTypeEnum


// WEBPACK FOOTER //
// ./src/enum/packageTypeEnum.js